import { Table, TableBody, TableContainer, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PriceDisplay } from "../../../../../components/common/PriceDisplay";
import {
    StyledTableCell,
    StyledTableHead,
    StyledTableRow,
} from "../../../../../components/table/BaseTable/BaseTable";
import { formatDecimalNumber, getDiscountedPricesForProduct, useLanguage } from "../../../../../utils";
import { roundToDecimalPlaces } from "../../../../../helpers/methods";

export const AgreementProductsReckoningTable = (props) => {
    const { products, agreementFinalSettlement } = props;
    const { t } = useTranslation();
    const language = useLanguage();

    const productRow = (agreementProduct) => {
        const { product, discount_proc } = agreementProduct;
        const effectiveFootage = product.footage_postconstruction ?? product.footage ?? 0
        const footageDifferenceM2 =
            (product.footage_postconstruction ?? product.footage ?? 0) - (product.footage ?? 0);
        const footageDifferencePercent = (footageDifferenceM2 / (product.footage ?? 1)) * 100;
        const pricing = getDiscountedPricesForProduct(product, discount_proc);
        const postConstructionPricingGross = roundToDecimalPlaces(pricing.gross_per_sqm, 2) * effectiveFootage
        const pricingDifference = postConstructionPricingGross - roundToDecimalPlaces(pricing.gross, 2)

        return (
            <StyledTableRow key={product.id}>
                <StyledTableCell>
                    {language === "pl" ? product.type?.name : product.type?.name_eng}
                </StyledTableCell>
                <StyledTableCell>{product.product_number}</StyledTableCell>
                <StyledTableCell>{product.name_full}</StyledTableCell>
                <StyledTableCell>
                    {product.footage
                        ? `${product.footage.toFixed(2)} m²`
                        : "-"}
                </StyledTableCell>
                <StyledTableCell>
                    {product.footage_postconstruction
                        ? `${product.footage_postconstruction.toFixed(2)} m²`
                        : "-"}
                </StyledTableCell>
                <StyledTableCell>
                    {!agreementFinalSettlement ? "-" : `${footageDifferenceM2 > 0 ? "+" : ""}${footageDifferenceM2.toFixed(2)} m²`} 
                </StyledTableCell>
                <StyledTableCell>
                    {!agreementFinalSettlement ? "-" : `${footageDifferencePercent > 0 ? "+" : ""}${formatDecimalNumber(footageDifferencePercent)} %`}
                </StyledTableCell>
                {/* <StyledTableCell>
                    <PriceDisplay price={!agreementFinalSettlement ? "-" : pricing.gross} />
                </StyledTableCell> */}
                <StyledTableCell>
                    <PriceDisplay price={!agreementFinalSettlement ? "-" : postConstructionPricingGross} />
                </StyledTableCell>
                <StyledTableCell>
                    <PriceDisplay price={!agreementFinalSettlement ? "-" : pricingDifference} />
                </StyledTableCell>
            </StyledTableRow>
        );
    };

    return (
        <TableContainer>
            <Table>
                <StyledTableHead>
                    <StyledTableRow>
                       <StyledTableCell>
                            {t("agreements.AgreementProductsReckoningTable.type")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsReckoningTable.number")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsReckoningTable.name")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsReckoningTable.footage")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t(
                                "agreements.AgreementProductsReckoningTable.footagePostconstruction",
                            )}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsReckoningTable.footageDifferenceM2")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t(
                                "agreements.AgreementProductsReckoningTable.footageDifferencePercent",
                            )}
                        </StyledTableCell>
                        {/* <StyledTableCell>
                            {t("agreements.AgreementProductsReckoningTable.totalGrossPrice")}
                        </StyledTableCell> */}
                        <StyledTableCell>
                            {t("agreements.AgreementProductsReckoningTable.totalGrossPriceAfterRecalculation")}
                        </StyledTableCell>
                        <StyledTableCell>
                            {t("agreements.AgreementProductsReckoningTable.totalGrossPriceDifference")}
                        </StyledTableCell>
                    </StyledTableRow>
                </StyledTableHead>
                <TableBody>
                    {products.map(productRow)}
                    {props.showTotalsAfterDiscount && products.length > 0 &&
                    <StyledTableRow>
                            <StyledTableCell colSpan={5}/> 
                            <StyledTableCell colSpan={1} align="left">
                                <Typography fontWeight={"bold"}>
                                    {t("agreements.AgreementProductsTable.total")}
                                </Typography>
                            </StyledTableCell>
                            <StyledTableCell colSpan={1} align="left">
                                <Typography fontWeight={"bold"}>
                               {!agreementFinalSettlement ? "-" : products.reduce((currvalue, accumulator)=>{
                                    const footageDifferenceM2 = (accumulator.product.footage_postconstruction ?? accumulator.product.footage ?? 0) - (accumulator.product.footage ?? 0);
                                    const footageDifferencePercent = (footageDifferenceM2 / (accumulator.product.footage ?? 1)) * 100;
                                    return currvalue + footageDifferencePercent
                                }, 0).toFixed(2) + "%"}
                                </Typography>
                            </StyledTableCell>
                            {/* <StyledTableCell colSpan={1} align="left">
                                <PriceDisplay style = {{fontWeight: "bold"}} price={!agreementFinalSettlement ? "-" : products.reduce((currvalue, accumulator)=>{
                                    const discountedPricing = getDiscountedPricesForProduct(accumulator.product, accumulator.discount_proc);
                                    return currvalue + discountedPricing.gross
                                }, 0)} />
                            </StyledTableCell> */}
                            <StyledTableCell colSpan={1} align="left">
                                <PriceDisplay style = {{fontWeight: "bold"}} price={!agreementFinalSettlement ? "-" : products.reduce((currvalue, accumulator)=>{
                                    const effectiveFootage = accumulator.product.footage_postconstruction ?? accumulator.product.footage ?? 0
                                    const pricing = getDiscountedPricesForProduct(accumulator.product, accumulator.discount_proc);
                                    const postConstructionPricingGross = roundToDecimalPlaces(pricing.gross_per_sqm, 2) * effectiveFootage
                                    return currvalue + roundToDecimalPlaces(postConstructionPricingGross, 2)
                                }, 0)} />
                            </StyledTableCell>
                            <StyledTableCell colSpan={1} align="left">
                                <PriceDisplay style = {{fontWeight: "bold"}} price={!agreementFinalSettlement ? "-" : products.reduce((currvalue, accumulator)=>{
                                    const effectiveFootage = accumulator.product.footage_postconstruction ?? accumulator.product.footage ?? 0
                                    const pricing = getDiscountedPricesForProduct(accumulator.product, accumulator.discount_proc);
                                    const postConstructionPricingGross = roundToDecimalPlaces(pricing.gross_per_sqm, 2) * effectiveFootage
                                    
                                    const difference = roundToDecimalPlaces(postConstructionPricingGross, 2) - roundToDecimalPlaces(pricing.gross, 2)
                                    return currvalue + difference
                                }, 0)} />
                            </StyledTableCell>
                        </StyledTableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    );
};
